// Module
var code = `<div class="grid grid-cols-5 gap-x-2"> <span ng-repeat="state in states" ng-class="{'bg-harvustorange/50': isAfter(state)}" class="bg-harvustorange col-span-1 h-2 rounded-xs" ui-state="state"></span> </div> `;
// Exports
export default code;